import { Directive, Input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { Subject, map } from 'rxjs';

import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { RemoveButtonStyle } from '../../picks/components/digital/pick-remove-button/remove-button-style';
import { RemoveButtonPosition } from '../../single-bet/remove-button-position-enum';
import { comboBetStateSelector, selectComboBetPicks } from '../selectors';
import { IComboBetState } from '../state';

@Directive()
export default abstract class BaseComboBetComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonPosition: RemoveButtonPosition;
    @Input() removeButtonStyle: RemoveButtonStyle;

    protected betslipType = BetslipType.Combo;

    protected onListRendered$ = new Subject<BetslipPick[]>();

    // in case it looks weird to you - you're right, but please have at the reason of this change https://vie.git.bwinparty.com/vanilla/monorepo/-/merge_requests/4433
    // we want to render the _important_ things first, ie the picksList
    protected isListRendered = toSignal(this.onListRendered$.pipe(map(() => true)), { initialValue: false });
    protected comboBetState: Signal<IComboBetState>;
    protected pickList: Signal<BetslipPick[]>;

    protected constructor(store: Store) {
        this.comboBetState = store.selectSignal(comboBetStateSelector);
        this.pickList = store.selectSignal(selectComboBetPicks);
    }

    protected pickTrackBy(_: number, pick: BetslipPick): string {
        return pick.id.toString();
    }
}
